const modifyButtonDefaultText = "Modifica Documento";
const confirmButtonDefaultText = "Conferma Documento";
const defaultUploadButtonText = "Carica Documento";
const defaultLoadingText = "Caricamento...";
export {
  confirmButtonDefaultText,
  defaultLoadingText,
  defaultUploadButtonText,
  modifyButtonDefaultText
};
//# sourceMappingURL=dropzone.strings.es.js.map
